export default "/static/dashboard/build/app/img/v2/16db7313533002b2703a51f7b409d16a.png";